import React, { useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import type { FeatureCollection } from 'geojson';

const SRC  = 'aviplan-safety-envelopes-src';
const FILL = 'aviplan-se-fill';
const LINE = 'aviplan-se-line';

const EMPTY: FeatureCollection = { type: 'FeatureCollection', features: [] };

// Color by clearance mode
const MODE_COLOR: mapboxgl.Expression = [
  'match', ['get', 'mode'],
  'operational', '#81C784',
  /* default icao_minimum */ '#66BB6A',
];

const SafetyEnvelopeLayer: React.FC<{
  map: mapboxgl.Map;
  data: FeatureCollection | null;
  visible: boolean;
}> = ({ map, data, visible }) => {

  useEffect(() => {
    if (map.getSource(SRC)) return;

    map.addSource(SRC, { type: 'geojson', data: EMPTY });

    map.addLayer({
      id: FILL, type: 'fill', source: SRC,
      paint: { 'fill-color': MODE_COLOR, 'fill-opacity': 0.14 },
    });
    map.addLayer({
      id: LINE, type: 'line', source: SRC,
      paint: { 'line-color': MODE_COLOR, 'line-width': 2 },
    });
  }, [map]);

  useEffect(() => {
    const src = map.getSource(SRC) as mapboxgl.GeoJSONSource | undefined;
    src?.setData(data ?? EMPTY);
  }, [data, map]);

  useEffect(() => {
    const vis = visible ? 'visible' : 'none';
    if (map.getLayer(FILL)) map.setLayoutProperty(FILL, 'visibility', vis);
    if (map.getLayer(LINE)) map.setLayoutProperty(LINE, 'visibility', vis);
  }, [visible, map]);

  return null;
};

export default SafetyEnvelopeLayer;
